import { createActionsSet } from "./helpers";

export default {
  getLicenses: createActionsSet("GET_LICENSES")
};
